<template lang="pug">
  .show-more(:class="alignClass")
    lei-btn.show-more__btn(@click="$emit('show-more')", size="sm") Show more
</template>
<script>
import LeiBtn from '../lei-components/LeiBtn'

export default {
  components: {
    LeiBtn,
  },
  props: {
    align: {
      type: String,
      default: 'center',
    },
  },
  computed: {
    alignClass () {
      const classes = {
        'center': 'align-center',
        'left': 'align-left',
      }
      return classes[this.align]
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .show-more
    padding-bottom 20px
    padding-left 1.5rem
    .align-left
      justify-content flex-start
    &__btn
      font-weight 600

</style>



// WEBPACK FOOTER //
// src/components/record-details/ShowMore.vue